<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="From"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="用户账号">
                <el-input v-model="queryForm.userName" style="width: 200px" clearable placeholder="请输入用户账号"></el-input>
            </el-form-item>
            <el-form-item label="卡片卡号">
                <el-input v-model="queryForm.cardNumber" style="width: 200px" clearable placeholder="请输入卡片卡号"></el-input>
            </el-form-item>
            <el-form-item label="卡片类型">
                <el-select
                    v-model="queryForm.cardType"
                    placeholder="请选择卡片类型"
                    clearable
                    size="small"
                    style="width: 200px"
                    @change="changears"
                >
                    <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="卡片额度" v-show="queryForm.cardType == 1">
                <el-select v-model="queryForm.detailId" placeholder="请选择卡片额度" style="width: 200px" clearable>
                    <el-option
                        v-for="item in limits"
                        :key="item.id"
                        :label="'额度:' + item.money + '元，' + '有效期:' + item.overTime + '年。'"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="商品种类" v-show="queryForm.cardType == 2">
                <el-select v-model="queryForm.detailId" placeholder="请选择商品种类" style="width: 200px" clearable>
                    <el-option
                        v-for="item in product"
                        :key="item.id"
                        :label="'商品:' + item.cardName + '，' + '有效期' + item.overTime + '年。'"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否使用">
                <el-select v-model="queryForm.isUsed" placeholder="请选择是否使用" clearable size="small" style="width: 200px">
                    <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="addtimeRange"
                    style="width: 200px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="绑定时间">
                <el-date-picker
                    v-model="addtimeBing"
                    style="width: 200px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>

                <!-- <el-date-picker
                        v-model="queryForm.bindTime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间"
                        type="datetime"
                        style="width: 200px"
                    >
                    </el-date-picker> -->
            </el-form-item>
            <el-form-item label="使用时间">
                <el-date-picker
                    v-model="addtimeUser"
                    style="width: 200px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
                <!-- <div class="block">
                    <el-date-picker
                        v-model="queryForm.useTime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间"
                        type="datetime"
                        style="width: 200px"
                    >
                    </el-date-picker>
                </div> -->
            </el-form-item>
            <el-form-item label="过期时间">
                <el-date-picker
                    v-model="addtimePast"
                    style="width: 200px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
                <!-- <div class="block">
                    <el-date-picker
                        v-model="queryForm.expiredTime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间"
                        type="datetime"
                        style="width: 200px"
                    >
                    </el-date-picker>
                </div> -->
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopCardList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopCard">批量生成</el-button>
                    <el-button type="primary" size="small" @click="showCardPresent">购物卡设置</el-button>
                    <el-button type="primary" size="small" @click="showCardShopping">礼品卡设置</el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopCard(null)"
                        >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <!-- <span title="下载模板" class="icon-box" @click="importTemplate">
                        <Icon color="#606266">
                            <ArrowDown />
                        </Icon>
                    </span> -->
                    <span title="导出数据" class="icon-box" @click="exportShopCardList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopCardList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="shopCardList" row-key="id" border @selection-change="handleSelectionChange" size="small" height="100%">
                <el-table-column align="center" type="selection" width="60"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="cardNumber" label="卡号" width="180"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="cardPassword" label="卡密" width="180">
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="cardType"
                    label="卡片类型"
                    width="180"
                    :formatter="sfktHouse"
                >
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="卡片内容" width="180">
                    <template slot-scope="scope">
                        <div class="car_text_type" style="text-align: left">
                            卡片类型：{{ scope.row.cardType == 1 ? '购物卡' : '礼品卡' }}
                        </div>
                        <div class="car_text_content" style="text-align: left" v-if="scope.row.cardType == 1 && scope.row.shopping">
                            卡片额度：{{ scope.row.shopping.money }}元
                        </div>
                        <div class="car_text_content" style="text-align: left" v-if="scope.row.leftMoney">
                            剩余额度：{{ scope.row.leftMoney }}元
                        </div>
                        <div class="car_text_content" style="text-align: left" v-if="scope.row.cardType == 2 && scope.row.product">
                            商品名称：{{ scope.row.product.productName }}
                        </div>
                        <div class="car_text_content" style="text-align: left" v-if="scope.row.cardType == 2 && scope.row.product">
                            商品价值：{{ scope.row.product.shopPrice }}元
                        </div>
                        <div class="car_text_content" style="text-align: left">
                            过期时间：{{ scope.row.cardType == 1 ? scope.row.shopping.expiredTime : scope.row.present.expiredTime }}年
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="用户" width="180">
                    <template slot-scope="scope">
                        <div v-if='scope.row.mppUser'>
                            <div class="car_text" style="text-align: left">账号：{{ scope.row.mppUser.userName }}</div>
                            <div class="car_text" style="text-align: left">手机：{{ scope.row.mppUser.userMobile }}</div>
                            <div class="car_text" style="text-align: left">昵称：{{ scope.row.mppUser.userNickname }}</div>
                            <div class="car_text" style="text-align: left">姓名：{{ scope.row.mppUser.userRealname }}</div>
                        </div>
                        <div class="car_text car_text_bing" style="text-align: left" v-else>
                            {{ '暂未绑定' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="isUsed"
                    label="是否用完"
                    :formatter="isHouse"
                    width="180"
                >
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="bindTime" label="绑定时间" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="useTime" label="使用时间" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="expiredTime" label="过期时间" width="180">
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="120">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="showCardUser(scop.row.id)">
                                <span class="operation-label">记录</span>
                            </div>
                            <div @click="deleteShopCard(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 批量生成/查看/修改信息 -->
            <el-dialog :title="shopCardStates[shopCardState]" :visible.sync="showDialog" width="400px" @close="closeDialog">
                <div>
                    <el-form :model="shopCard" ref="shopCardForm" :rules="rules" label-width="80px" :inline="true" size="small">
                        <el-form-item label="选择类型" prop="cardType">
                            <el-radio v-model="shopCard.cardType" label="1" @change="changeColor">购物卡</el-radio>
                            <el-radio v-model="shopCard.cardType" label="2" @change="changeColor">礼品卡</el-radio>
                        </el-form-item>
                        <el-form-item label="卡片额度" prop="detailId" v-if="!radios">
                            <GridSelect
                                style="width: 200px"
                                title="选择额度"
                                labelName="money"
                                labelValue="id"
                                :value="shopCard.money"
                                :limit="1"
                                size="small"
                                placeholder="请选择额度"
                                @getValue="getValuebrandId"
                                :columns="SHOPCARD_code"
                                :searchs="SHOPCARD_search"
                                dataListUrl="/shop/shopcardshopping/findList"
                                entityBeanName="shopcardcash"
                                queryEntityUrl="/shop/shopcardcash/get"
                            >
                            </GridSelect>
                        </el-form-item>
                        <!-- 购物卡数量 -->
                        <el-form-item label="卡片数量" prop="number" v-if="!radios">
                            <el-input style="width: 200px" v-model.number="shopCard.number" placeholder="请输入数量"></el-input>

                            <!-- <el-input-number
                                v-model="shopCard.number"
                                @change="handleChange"
                                :min="1"
                                style="width: 200px"
                                label="描述文字"
                            ></el-input-number> -->
                        </el-form-item>

                        <el-form-item label="商品名称" prop="detailId" v-if="radios">
                            <GridSelect
                                style="width: 200px"
                                title="选择商品"
                                labelName="cardName"
                                labelValue="id"
                                :value="shopCard.cardName"
                                :limit="1"
                                size="small"
                                placeholder="请选择产品"
                                @getValue="getValuebrandId"
                                :columns="SHOPCARD_code1"
                                :searchs="SHOPCARD_search1"
                                dataListUrl="/shop/shopcardpresent/findList"
                                entityBeanName="shopPresent"
                                queryEntityUrl="/shop/shopcardpresent/get"
                            >
                            </GridSelect>
                        </el-form-item>
                        <el-form-item label="卡片数量" prop="number" v-if="radios">
                            <el-input style="width: 200px" v-model.number="shopCard.number" placeholder="请输入数量"></el-input>
                            <!-- <el-form-item label="卡片数量" prop="number" v-if="radios">
                            <el-input-number
                                v-model="shopCard.number"
                                @change="handleChange"
                                :min="1"
                                style="width: 200px"
                                label="描述文字"
                            ></el-input-number> -->
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="shopCardState != 'check'">确定</el-button>
                </div>
            </el-dialog>
            <el-drawer
                title="购物卡管理"
                :visible.sync="cardPresentStatus"
                direction="rtl"
                size="70%"
                :before-close="cardPresentClose">
                <ShopCardShopping></ShopCardShopping>
            </el-drawer>
            <el-drawer
                title="礼品卡管理"
                :visible.sync="cardShoppingStatus"
                direction="rtl"
                size="70%"
                :before-close="cardShoppingClose">
                <ShopCardPresent></ShopCardPresent>
            </el-drawer>
            <el-drawer
                title="使用记录"
                :visible.sync="cardUserStatus"
                direction="rtl"
                size="70%"
                :before-close="cardUserClose">
                <ShopCardUse ref="shopUse"></ShopCardUse>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import ShopCardPresent from './ShopCardPresent.vue';
import ShopCardShopping from './ShopCardShopping.vue'
import { SHOPCARD, SHOPCARD_SEARCH, SHOPCARD1, SHOPCARD_SEARCH1 } from '@/utils/constant.js' 
import ShopCardUse from '@/components/shop/ShopCardUse.vue';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect,
        ShopCardPresent,
        ShopCardShopping,
        ShopCardUse
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopCardList();
                this.getShopCardList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopCardList();
                this.getShopCardList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            SHOPCARD_code: SHOPCARD,
            SHOPCARD_search: SHOPCARD_SEARCH,
            SHOPCARD_code1: SHOPCARD1,
            SHOPCARD_search1: SHOPCARD_SEARCH1, 
            cardPresentStatus: false,
            cardShoppingStatus: false,
            cardUserStatus: false,
            addtimeBing: [], //绑定时间
            addtimeUser: [], //使用时间
            addtimePast: [], //过期时间
            addtimeRange: [], //创建时间
            arr: [],
            newarr: [],
            limits: [],
            gift: [],
            product: [],
            // productName: [],
            value: '',
            options: [],
            options1: [
                {
                    value: '1',
                    label: '购物卡'
                },
                {
                    value: '2',
                    label: '礼品卡'
                }
            ],
            options2: [
                {
                    value: '1',
                    label: '是'
                },
                {
                    value: '0',
                    label: '否'
                }
            ],
            region: '',
            //数量
            num: 1,
            sum: 1,
            // 单选
            radio: '1',
            radios: false,
            queryForm: {
                // id: '', //ID
                cardNumber: '', //卡号
                cardPassword: '', //卡密
                cardType: '', //卡类型
                detailId: '', //卡内容
                userId: '', //用户
                isUsed: '', //否是使用
                isbind:'',//是否绑定
                bindTime: '',//绑定时间
                isused:'',//是否使用
                useTime: '', //使用时间
                expiredTime: '', //过期时间
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopCardState: 'add',
            shopCardStates: {
                add: '批量生成卡片'
            },

            multipleSelection: [],
            shopCardList: [],
            //传后台
            shopCard: {
                cardType: '1',
                detailId: null,
                number: ''
            },
            btnLoading: false,
            rules: {
                number: [
                    { required: true, message: '数量不能为空', trigger: 'blur' },
                    // { type: 'number', message: '过期时间必须为数字值' }
                ],
                cardType: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
                detailId: [{ required: true, message: '额度不能为空', trigger: 'blur' }],
                detail: [{ required: true, message: '产品不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getShopCardList();
    },
    methods: {
        getValuebrandId(value) {
            console.log("value",value)
            this.shopCard.detailId = value;
        },

        isHouse(row, index) {
            if (row.isUsed == '0') {
                return '否';
            } else if (row.isUsed == '1') {
                return '是';
            }
        },
        sfktHouse(row, index) {
            if (row.cardType == '1') {
                return '购物卡';
            } else if (row.cardType == '2') {
                return '礼品卡';
            }
        },
        handleChange(value) {
            console.log(value); //数量
        },
        //单选
        changeColor(param) {
            console.log(param); //1/2
            //判断label值为2，也就是否时候隐藏
            if (param === '2') {
                this.radios = true;
            } else {
                this.radios = false;
            }
            // this.shopCard.number = 1;
            this.$refs.shopCardForm.clearValidate();
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopCardList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopCardList = [];
        },
        resetDialog() {
            //搜索重置
            this.shopCardState = 'add';
            this.showDialog = false;
            this.queryForm = {
                // id: '', //ID
                cardNumber: '', //卡号
                cardPassword: '', //卡密
                cardType: '', //卡类型
                detailId: '', //卡内容
                userId: '', //用户
                isUsed: '', //否是使用
                isbind:'',//是否绑定
                bindTime: '',//绑定时间
                isused:'',//是否使用
                useTime: '', //使用时间
                expiredTime: '', //过期时间
            };
            this.addtimeRange = [];
            this.addtimeBing = [];
            this.addtimeUser = [];
            this.addtimePast = [];
            // this.$refs.shopCardForm.clearValidate();
            this.getShopCardList();
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$router.replace(from.path);
            });
        },
        //关闭
        closeDialog() {
            // this.$router.push('/shop/ShopCard');
            // this.$router.push('/shop/emptyPage');
            // this.changeColor();
            // this.$router.go(0);
            this.shopCard = {
                cardType: '1',
                number: '1'
                // detailId: null
            };
            this.shopCard.cardName = null;
            this.shopCard.money = null;
            this.radios = false;
            this.showDialog = false;
            this.$refs.shopCardForm.clearValidate();
            this.$refs.shopCardForm.resetFields();
        },

        submitForm() {
            if (this.shopCardState == 'add') {
                this.$refs.shopCardForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        console.log(this.shopCard);
                        post(`/shop/shopcard/addBatch`, { ...this.shopCard }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopCardList();
                                this.resetDialog();
                                this.getShopCardList();
                            }
                        });
                    }
                });
            } else if (this.shopCardState == 'edit') {
                this.$refs.shopCardForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/shopcard/edit`, { ...this.shopCard }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopCardList();
                                this.resetDialog();
                                this.getShopCardList();
                            }
                        });
                    }
                });
            }
            // this.closeDialog();
            // this.showDialog = false;
            // this.getShopCardList();
        },
        addShopCard() {
            this.showDialog = true;
            this.shopCardState = 'add';
        },
        checkShopCard(shopCardId) {
            console.log(shopCardId);
            this.currentShopCardId = shopCardId;

            this.getShopCardById();
            this.showDialog = true;
            this.shopCardState = 'check';
        },
        editShopCard(shopCardId) {
            console.log('shopCard', shopCardId);
            if (shopCardId) {
                this.currentShopCardId = shopCardId;
                this.getShopCardById();
            } else {
                this.shopCard = { ...this.shopCard, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopCardState = 'edit';
        },
        deleteShopCard(shopCardId) {
            let ids = '';
            if (shopCardId) {
                ids = shopCardId;
            } else {
                ids = this.multipleSelection.map((shopCard) => shopCard.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/shopcard/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopCardList();
                            this.getShopCardList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopCardList() {
            this.resetShopCardList();
            this.getShopCardList();
        },
        changears() {
            this.queryForm.detailId = '';
            this.changearr();
        },
        changearr() {
            // this.loading = true;
            get(`/shop/shopcardcash/findAll`, { ...this.queryForm }).then((res) => {
                // this.loading = false;
                if (res.success) {
                    this.arr = res.list;
                    // this.limits = res.list;

                    this.limits = this.arr.sort((a, b) => a.money - b.money);
                    // console.log(this.arr);
                    // const id = 'money';
                    // this.limits = this.arr.reduce((all, next) => (all.some((item) => item[id] == next[id]) ? all : [...all, next]), []);
                    // console.log(this.limits);
                }
            });
            // this.loading = true;
            get(`/shop/shopcardpresent/findAll`, { ...this.queryForm }).then((res) => {
                // this.loading = false;
                if (res.success) {
                    console.log(res);
                    this.newarr = res.list;
                    console.log(this.newarr);
                    const id = 'productId';
                    this.product = this.newarr.reduce((all, next) => (all.some((item) => item[id] == next[id]) ? all : [...all, next]), []);
                    console.log(this.product);
                    // this.shopCardBlackgoldList = res.page.list;
                    // this.totalNum = res.page.total;
                }
            });
            // this.arr = this.options.map((item) => {
            //     return { money: item.money, id: item.id, detailId: item.detailId };
            // });
            // this.newarr = this.arr.filter((item) => item.money !== null);
            // const id = 'money';
            // this.limit = this.newarr.reduce((all, next) => (all.some((item) => item[id] == next[id]) ? all : [...all, next]), []);
            // console.log(this.limit);
            // this.gift = this.options.map((item) => {
            //     return { cardName: item.cardName, id: item.id, detailId: item.detailId };
            // });
            // this.product = this.gift.filter((item) => item.cardName !== null);
            // const id1 = 'cardName';
            // this.kind = this.product.reduce((all, next) => (all.some((item) => item[id1] == next[id1]) ? all : [...all, next]), []);
            // console.log(this.kind);
            // this.queryForm.detailId = '';
        },

        getShopCardList(query = {}) {
            // this.queryForm.startAddtime = '';
            // this.queryForm.endAddtime = '';
            // if (this.addtimeRange != null) {
            //     this.queryForm.createStartTime = this.addtimeRange[0];
            //     this.queryForm.createEndTime = this.addtimeRange[1];
            // }
            this.queryForm.useStartTime = '';
            this.queryForm.useEndTime = '';
            if (this.addtimeUser != null) {
                this.queryForm.useStartTime = this.addtimeUser[0];
                this.queryForm.useEndTime = this.addtimeUser[1];
            }
            this.queryForm.bindStartTime = '';
            this.queryForm.bindEndTime = '';
            if (this.addtimeBing != null) {
                this.queryForm.bindStartTime = this.addtimeBing[0];
                this.queryForm.bindEndTime = this.addtimeBing[1];
            }
            this.queryForm.expiredStartTime = '';
            this.queryForm.expiredEndTime = '';
            if (this.addtimePast != null) {
                this.queryForm.expiredStartTime = this.addtimePast[0];
                this.queryForm.expiredEndTime = this.addtimePast[1];
            }
            this.loading = true;
            get(`/shop/shopcard/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    console.log(res.page.list);
                    this.shopCardList = res.page.list;
                    this.options = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getShopCardById() {
            get(`/mpp/shopcard/get`, { id: this.currentShopCardId }).then((res) => {
                if (res.success) {
                    this.shopCard = { ...this.shopCard, ...res.shopCard };
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopCardList() {
            // this.btnLoading = true;
            exprotExcel(`/shop/shopcard/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        // importTemplate() {
        //     this.btnLoading = true;
        //     importTemplate(`/mpp/shopcard/importTemplate`, this.btnLoading);
        // },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/shopcard/importData`, formData);
            this.refreshShopCardList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopCardList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopCardList();
        },
        showCardPresent(){
            this.cardPresentStatus = true
        },
        showCardShopping(){
            this.cardShoppingStatus = true
        },
        showCardUser(id){
            this.cardUserStatus = true
            this.$nextTick(()=>{
                this.$refs.shopUse.show(id)
            })
        },
        cardPresentClose(){
            this.cardPresentStatus = false
        },
        cardShoppingClose(){
            this.cardShoppingStatus = false
        },
        cardUserClose(){
            this.cardUserStatus = false
        },
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.limit {
    margin-top: 20px;
    // margin-bottom: 10px;
}

.sum {
    margin-top: 20px;
}

.car_pup {
    margin-left: 40px;
}
.car_text {
    font-size: 12px;
    color: #606266;
}
.car_text_type {
    font-size: 12px;
}
.car_text_content {
    // margin-top: 5px;
    font-size: 12px;
}
.car_text_bing {
    margin-left: 45px;
    // margin-left: 50%;
}
</style>
